import { FunctionComponent } from "react"
import { Link } from "react-router-dom"
import logoUnl from '../../assets/img/logo_unl.svg'

interface ContainerProps {
    linkAnterior: string,
    linkSiguiente: string,
    linkOmitir?: string,
}

const AnteriorSiguienteButtons: FunctionComponent<ContainerProps> = (props) => {
    const { linkAnterior, linkSiguiente, linkOmitir } = props
    const col = linkOmitir ? 3 : 4

    return (
        <>
        <div className="row justify-content-center bottommargin topmargin">
            <div className={`col-${col} d-none d-lg-block`}></div>
            <div className={`col-12 col-md-${col}`}>
                <div className="row justify-content-center">
                        <Link to={linkAnterior} className="button">Anterior</Link>
                        <Link to={linkSiguiente} className="button">Siguiente</Link>
                    { linkOmitir ?
                        <Link to={linkOmitir} className="button buttonomitir"> Omitir </Link>
                    : ''}
                </div>
            </div>
            <div className={`col-${col} d-none d-lg-inline ml-auto`}>
                <div className="logo">
                    <img alt="logo unl" src={logoUnl} />
                </div>
            </div>
        </div>
        <div className="row justify-content-center d-lg-none bottommargin">
            <div className="logo">
                <img alt="logo unl" src={logoUnl} />
            </div>
        </div>
        </>
    )
}
export default AnteriorSiguienteButtons
